import { Page } from '../../config';

export const adaptProductOne = (data: Page) => {
  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    category: data.category,
    image: data.image,
    text: data.text,
  };
};
